<template>
  <!-- Info Bar -->
  <div class="q-pa-md">
    <q-card class="my-card" flat bordered>
      <q-item>
        <q-item-section avatar>
          <q-icon name="shopping_cart" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Odemeler</q-item-label>
        </q-item-section>
      </q-item>
      <q-separator />
      <q-card-section horizontal>
        <q-card-section> </q-card-section>
        <q-separator vertical />
        <q-card-section class="col-4">
          Bu sayfadan gecmis odemeleri goruntuleyebilirsiniz.
        </q-card-section>
      </q-card-section>
    </q-card>
  </div>

  <!-- Statistics -->
  <div class="row">
    <div class="col-xs-12 col-sm-6 col-lg-4 q-pa-md">
      <q-card class="bg-secondary text-white">
        <q-card-section>
          <div class="text-subtitle2"><q-icon name="paid" /> Toplam</div>
          <div class="text-h6">{{ totalCash + totalCc }} TL</div>
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12 col-sm-6 col-lg-4 q-pa-md">
      <q-card class="bg-secondary text-white">
        <q-card-section>
          <div class="text-subtitle2"><q-icon name="payments" /> nakit</div>
          <div class="text-h6">{{ totalCash }} TL</div>
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12 col-sm-6 col-lg-4 q-pa-md">
      <q-card class="bg-secondary text-white">
        <q-card-section>
          <div class="text-subtitle2">
            <q-icon name="credit_card" /> kredikarti
          </div>
          <div class="text-h6">{{ totalCc }} TL</div>
        </q-card-section>
      </q-card>
    </div>
  </div>

  <!-- Timestamp Selection -->
  <div class="row">
    <!-- Starting Timestamp -->
    <div class="col-xs-12 col-sm-6 col-lg-5 q-pa-md">
      <q-input v-model="inputStart" filled label="Baslangic Tarihi">
        <template #append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy
              ref="qDateProxy"
              cover
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date v-model="inputStart" mask="YYYY-MM-DD">
                <div class="row items-center justify-end">
                  <q-btn v-close-popup label="Kapat" color="primary" flat />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <!-- Ending Timestamp -->
    <div class="col-xs-12 col-sm-6 col-lg-5 q-pa-md">
      <q-input v-model="inputEnd" filled label="Bitis Tarihi">
        <template #append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy
              ref="qDateProxy"
              cover
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date v-model="inputEnd" mask="YYYY-MM-DD">
                <div class="row items-center justify-end">
                  <q-btn v-close-popup label="Kapat" color="primary" flat />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <!-- Action Button -->
    <div class="col-xs-12 col-sm-6 col-lg-2 q-pa-md">
      <q-btn
        label="Getir"
        color="amber"
        class="full-width"
        icon="get_app"
        @click="onSubmit"
      />
    </div>
  </div>

  <!-- Payments Table -->
  <div class="q-pa-md">
    <PaymentsTable :start="start" :end="end" />
  </div>
</template>
<script>
import { ref } from 'vue'
import moment from 'moment'
import axios from 'axios'
import PaymentsTable from '../components/payments/Table.vue'
import * as timestuff from '../utils/timetravel'

export default {
  components: {
    PaymentsTable,
  },
  setup() {
    const inputStart = ref(moment().startOf('month').format('YYYY-MM-DD'))
    const inputEnd = ref(moment().endOf('month').format('YYYY-MM-DD'))
    const start = ref(timestuff.getTimestampFromDate(inputStart.value))
    const end = ref(timestuff.getTimestampFromDate(inputEnd.value))
    const totalCash = ref(0)
    const totalCc = ref(0)

    function onSubmit() {
      start.value = timestuff.getTimestampFromDate(inputStart.value)
      end.value = timestuff.getTimestampFromDate(inputEnd.value)

      axios
        .get(`/purchase/stats?start=${start.value}&end=${end.value}`)
        .then((response) => {
          totalCash.value = response.data.totalCash
          totalCc.value = response.data.totalCc
        })
    }

    return {
      inputStart,
      inputEnd,
      start,
      end,
      totalCash,
      totalCc,
      onSubmit,
    }
  },
}
</script>
